import { command, serviceCommands } from '@estee/elc-service-bus';
import { AuthSessionRepository } from '../repositories/AuthSessionRepository';

export class ClearAuthSessionUseCase {
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(private readonly authSessionRepository: AuthSessionRepository) {}

    public execute = async () => {
        void command(serviceCommands.CLEAR_USER_DATA);

        this.authSessionRepository.clearSession();
        if (this.authSessionRepository.enableCareConfig) {
            this.authSessionRepository.clearCareSession();
        }

        await this.authSessionRepository.ensureAuthSession();
        if (this.authSessionRepository.enableCareConfig) {
            await this.authSessionRepository.ensureCareAuthSession();
        }
    };
}
